import {Role, User} from "@/data/entities/user";
import {createContext, useContext} from "react";
import {SetStateFn} from "@/utils/SetStateUtils";

type AuthContextType = {
    user: User,
    setUser: SetStateFn<User>,
    mainRole: Role,
};

export const AuthContext = createContext<AuthContextType>({} as AuthContextType);

const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth must be used inside AuthProvider");
    }

    return ctx;
}

export default useAuth;